import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import ForeignRefundForRefundOfRefundsViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/foreign/foreignRefundForRefundOfRefundsViewModel";
import { TransferRefundForRefundOfRefundsView } from "../transferRefundForRefundOfRefundsView";

const ForeignRefundForRefundOfRefundsView: ViewComponent<ForeignRefundForRefundOfRefundsViewModel> = observer(({ vm }) => (
  <TransferRefundForRefundOfRefundsView key={vm.name} vm={vm} />
));

registerView(ForeignRefundForRefundOfRefundsView, ForeignRefundForRefundOfRefundsViewModel);
